export function formatDateRecordCreated(dateRecordCreated: string) {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric"
  };
  return new Date(dateRecordCreated).toLocaleString(undefined, options);
}
